import {BASE_URL,AUTH_TOKEN } from "./Env";


// export const headers = {};
export const headers = {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${AUTH_TOKEN}`
};




// User
export const APIUserLogIn = BASE_URL+"/api/user/login";
export const APIUserList = BASE_URL+"/api/user/list";
export const APIUserStore = BASE_URL+"/api/user/store";
export const APIUserUpdate = BASE_URL+"/api/user/update";
export const APIUserPassword = BASE_URL+"/api/user/password";
export const APIUserDelete = BASE_URL+"/api/user/delete";

// Contact Us
export const APIContactUsList = BASE_URL+"/api/contact-us/list";
export const APIContactUsShow = BASE_URL+"/api/contact-us/show/";
export const APIContactUsUpdate = BASE_URL+"/api/contact-us/update";
export const APIContactUsDelete = BASE_URL+"/api/contact-us/delete";

// Prices
export const APIPricesList = BASE_URL+"/api/prices/list";
export const APIPricesStore = BASE_URL+"/api/prices/store";
export const APIPricesUpdate = BASE_URL+"/api/prices/update";
export const APIPricesDelete = BASE_URL+"/api/prices/delete";

// Commodities
export const APICommodityList = BASE_URL+"/api/commodities/list";
export const APICommodityStore = BASE_URL+"/api/commodities/store";
export const APICommodityUpdate = BASE_URL+"/api/commodities/update";
export const APICommodityDelete = BASE_URL+"/api/commodities/delete";

// Vendors
export const APIVendorList   = BASE_URL + "/api/vendors/list";
export const APIVendorStore  = BASE_URL + "/api/vendors/store";
export const APIVendorUpdate = BASE_URL + "/api/vendors/update";
export const APIVendorDelete = BASE_URL + "/api/vendors/delete";

// Handlers
export const APIHandlerList   = BASE_URL + "/api/handlers/list";
export const APIHandlerStore  = BASE_URL + "/api/handlers/store";
export const APIHandlerUpdate = BASE_URL + "/api/handlers/update";
export const APIHandlerDelete = BASE_URL + "/api/handlers/delete";

// LPO
export const APILPOList = BASE_URL+"/api/lpo/list";
export const APILPOShow = BASE_URL+"/api/lpo/show";
export const APILPOUpdate = BASE_URL+"/api/lpo/update";
export const APILPODelete = BASE_URL+"/api/lpo/delete";
export const APILPOStatus = BASE_URL+"/api/lpo/status";

// LPO II
export const APILPOIIStore   = BASE_URL + "/api/lpo-II/store";
export const APILPOIIList    = BASE_URL + "/api/lpo-II/list";
export const APILPOIIShow    = BASE_URL + "/api/lpo-II/show";
export const APILPOIIUpdate  = BASE_URL + "/api/lpo-II/update";
export const APILPOIIDelete  = BASE_URL + "/api/lpo-II/delete";
export const APILPOIIStatus  = BASE_URL + "/api/lpo-II/status";

// Career
export const APICareerList = BASE_URL+"/api/career/list";
export const APICareerStore = BASE_URL+"/api/career/store";
export const APICareerUpdate = BASE_URL+"/api/career/update";
export const APICareerDelete = BASE_URL+"/api/career/delete";

// Application
export const APIApplicationList = BASE_URL+"/api/application/list";
export const APIApplicationUpdate = BASE_URL+"/api/application/update";
export const APIApplicationDelete = BASE_URL+"/api/application/delete";
export const APIBaseCv = BASE_URL + "/api/application/";
export const APIDownloadCv = "/download-cv";
export const APIViewCv = "/view-cv";
// Emails
export const APIEmailsList = BASE_URL+"/api/emails/list";
export const APIEmailsStore = BASE_URL+"/api/emails/store";
export const APIEmailsUpdate = BASE_URL+"/api/emails/update";
export const APIEmailsDelete = BASE_URL+"/api/emails/delete";